import React, { memo } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import styled from "styled-components";
import { useNavigate } from 'react-router-dom'

const Boton = styled.button`
    background-color: transparent;
    color: ${({ theme }) => theme?.text || "#222"};
    border: none;
    transition: ease-in-out 200ms;    
    cursor: pointer;
    line-height: 1.5;
    padding: 0.15rem 0.5rem;
    &:hover {
        background-color: ${({ theme }) => theme?.backgroundVolverHover || "#dedede"};
        color: ${({ theme }) => theme?.text || "#222"};
        transition: ease-in-out 200ms;
        border-radius: 0.2rem;
    }
`;

const ButtonVolver = ({ children ="Volver", onVolver, className = "", ...resto }) => {
    
    const navigate = useNavigate();

    const volver = () => {
        if (onVolver) {
            onVolver();
            return;
        } 
        navigate(-1);
    } 

    return (
        <Boton
            {...resto}
            variant="transparent"
            className={className}
            onClick={volver}
        >
            <FontAwesomeIcon icon={faChevronLeft} style={{"marginRight": "0.35rem"}} />
            {children}
        </Boton> 
    )
}

export default memo(ButtonVolver);